import Container from "@/components/ui/Container";
import bannerPng from "@/assets/All-Banner 1.png";
import { useTranslation } from "react-i18next";

export function AppPromo() {
  const { t } = useTranslation();

  return (
    <section className="pt-12 bg-teal-700 text-white">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="flex justify-around">
            <img src={bannerPng} alt={t('appPromo.imageAlt')} />
          </div>
          <div className="pb-2">
            <h3 className="text-2xl font-extrabold">
              {t('appPromo.title')}
            </h3>
            <p className="mt-2 text-teal-100">
              {t('appPromo.description')}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                className="px-4 py-2 rounded-xl bg-black text-white inline-flex items-center gap-2"
                href="#"
              >
                {t('appPromo.appStore')}
              </a>
              <a
                className="px-4 py-2 rounded-xl bg-black text-white inline-flex items-center gap-2"
                href="#"
              >
                {t('appPromo.googlePlay')}
              </a>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
